<div class="individual-verification">
  <div class="verification-label" [class]="IndividualVerificationStatus[this.individualDto.verificationInfo.status]">
    <i class="icon ic-verification-20"></i>

    <div>
      <div class="verification-label-title">ID Verification</div>
      <div class="verification-label-status">
        {{ IndividualVerificationStatusLabels[this.individualDto.verificationInfo.status] }}
      </div>
    </div>
  </div>

  <div class="controls">
    @if (this.individualDto.verificationInfo.status == IndividualVerificationStatus.NotVerified) {
      <button
        type="button"
        class="btn btn-secondary btn-icon"
        [disabled]="isLoading()"
        (click)="sendOnVerification()"
      >
        <i class="icon ic-sent-mail-20"></i>
      </button>
    } @else if (this.individualDto.verificationInfo.status == IndividualVerificationStatus.Verifying) {
      <button
        type="button"
        class="btn btn-secondary btn-icon"
        placement="bottom"
        ngbTooltip="Cancel ID Verification"
        tooltipClass="tooltip-info"
        [disabled]="isLoading()"
        (click)="voidVerification()"
      >
        <i class="icon ic-void-mail-20"></i>
      </button>
    } @else if (this.individualDto.verificationInfo.status == IndividualVerificationStatus.Verified) {
      <div ngbDropdown>
        <button
          ngbDropdownToggle
          type="button"
          class="btn btn-secondary btn-icon"
          [disabled]="isLoading()"
        >
          <i class="icon ic-more-horizontal-20"></i>
        </button>

        <div ngbDropdownMenu class="common-dropdown-menu">
          <!-- <button
            ngbDropdownItem
            type="button"
            [disabled]="isLoading()"
            (click)="reviewDocuments()"
          >
            <i class="icon ic-documents-20"></i>
            <span>Review Documents</span>
          </button> -->

          <button
            ngbDropdownItem
            type="button"
            [disabled]="isLoading()"
            (click)="downloadCertificate()"
          >
            <i class="icon ic-documents-20"></i>
            <span>Download Verification Certificate</span>
          </button>

          <button
            ngbDropdownItem
            type="button"
            [disabled]="isLoading()"
            (click)="initiateNewVerification()"
          >
            <i class="icon ic-edit-and-send-20"></i>
            <span>Initiate New Verification</span>
          </button>

          <!-- <button
            ngbDropdownItem
            type="button"
            [disabled]="isLoading()"
            (click)="resetVerification()"
          >
            <i class="icon ic-reset-20"></i>
            <span>Reset Verification</span>
          </button> -->
        </div>
      </div>
    } @else if (this.individualDto.verificationInfo.status == IndividualVerificationStatus.VerificationFailed) {
      <div ngbDropdown>
        <button
          ngbDropdownToggle
          type="button"
          class="btn btn-secondary btn-icon"
        >
          <i class="icon ic-more-horizontal-20"></i>
        </button>

        <div ngbDropdownMenu class="common-dropdown-menu">
          <button
            ngbDropdownItem
            type="button"
            [disabled]="isLoading()"
            (click)="initiateNewVerification()"
          >
            <i class="icon ic-edit-and-send-20"></i>
            <span>Initiate New Verification</span>
          </button>

          <button
            ngbDropdownItem
            type="button"
            [disabled]="isLoading()"
            (click)="resetVerification()"
          >
            <i class="icon ic-reset-20"></i>
            <span>Reset Verification</span>
          </button>
        </div>
      </div>
    } @else if (this.individualDto.verificationInfo.status == IndividualVerificationStatus.Cancelled) {
      <div ngbDropdown>
        <button
          ngbDropdownToggle
          type="button"
          class="btn btn-secondary btn-icon"
        >
          <i class="icon ic-more-horizontal-20"></i>
        </button>

        <div ngbDropdownMenu class="common-dropdown-menu">
          <button
            ngbDropdownItem
            type="button"
            [disabled]="isLoading()"
            (click)="resetVerification()"
          >
            <i class="icon ic-reset-20"></i>
            <span>Reset Verification</span>
          </button>
        </div>
      </div>
    }
  </div>
</div>
